/**
 * PATH: packages/job-hub/src/jobs/qa/patchItpCover.ts
 * FILE_ID: JOBHUB-QA-PATCH-ITP-COVER-001
 * PURPOSE: Change the cover image or title inside HTML that is already open.
 * WHY: A dirty or signed export must not be rebuilt from scratch.
 */
import { itpCoverImageStyle, itpHideList, type ItpCoverFields } from './itpCover'

function documentOf(html: string): Document {
  return new DOMParser().parseFromString(html, 'text/html')
}

function serialise(doc: Document): string {
  return `<!doctype html>\n${doc.documentElement.outerHTML}`
}

export function patchItpCoverImage(
  html: string,
  src: string | null,
  size?: { widthMm?: number | null; heightMm?: number | null },
): string {
  const doc = documentOf(html)
  const current = doc.querySelector('.itp-cover-photo')
  if (!src) {
    current?.remove()
    return serialise(doc)
  }
  const image = doc.createElement('img')
  image.className = 'itp-cover-photo'
  image.src = src
  image.alt = ''
  image.setAttribute(
    'style',
    size
      ? itpCoverImageStyle(size.widthMm, size.heightMm)
      : (current?.getAttribute('style') ?? itpCoverImageStyle()),
  )
  if (current) current.replaceWith(image)
  else {
    const title = doc.querySelector('.itp-cover-title')
    if (title) title.insertAdjacentElement('afterend', image)
    else doc.body.prepend(image)
  }
  return serialise(doc)
}

export function patchItpInclude(html: string, include: ItpCoverFields['include']): string {
  const doc = documentOf(html)
  doc.body.setAttribute('data-itp-hide', itpHideList(include))
  return serialise(doc)
}

export function patchItpCoverTitle(html: string, title: string): string {
  const doc = documentOf(html)
  const node = doc.querySelector('.itp-cover-title')
  if (node) node.textContent = title
  return serialise(doc)
}
